export default {
	index: {
		text1: "邀请",
		text2: "资产",
		text3: "账单",
		text4: "专区",
		text5: "一星公约",
		text6: "认购",
		text7: "二星公约",
		text8: "简介",
		text9: "加入我们社区",
		text10: "绑定上级",
		text11: "请输入推荐人地址",
		text12: "确定",
		text13: "贡献激励池",
		text14: "奖励剩余",
		text15: "待开放",
		text16: "合作伙伴",
		
	},
	wallet: {
		text1: "资产总估值",
		text2: "账单",
		text3: "余额",
		text4: "转出",
		text5: "白名单权益",
		text6: "IDO权益",
		text7: "认购",
		text8: "兑换",

	},
	dui :{
		text1: "兑换白名单权益",
	
	},
	//认购
	pawn: {
		text1: "收益次日18:18结算，日化收益中70%结算为USDT，30%结算为相应等值的UES代币，UES市场价值为3U。",
		text2: "认购",
		text3: "枚",
		text4: "一星公约",
		text5: "每日收益",
		text6: "二星公约",
		text7: "三星公约",
		text8: "Plus公约",
		
	},
	
	zy: {
		text1: "收益中",
		text2: "已到期",
		text3: "数量",
		text5: "已收益",
		text4: "认购日期",
		
	},
	team: {
			text1: "当前等级",
			text2: "我的认购",
			text3: "小区业绩",
			text4: "我的推荐人",
			text5: "推荐人的认购",
			text6: "我的团队",
			text7: "业绩总和",
			text8: "小区业绩",
			text9: "团队人数",
			text10: "我的推荐",
			text11: "认购数量",
			text12: "邀请链接",
	},
	withdrawal: {
			"text1": "提现数量",
			"text2": "到账",
			"text3": "手续费",
			"text4": "钱包余额",
			"text5": "转出冻结",
			"text6": "确定",
			"text7": "请输入转出数量",
		
	},
	record: {
			text1: "类型",
			text2: "数量",
			text3: "时间",
	},
	header: {
		text1: '更多',
		text2: '推荐链接',
		text3: '首页',
		text4: '钱包',
		text5: '认购',
		text6: '我的公约',
		text7: '我的团队',
		text8: 'RLP白名单',

	},
	lan: {
		text1: '英语',
		text2: '简体',
		text3: '繁体',
		text4: '泰语',
		text5: '韩语',
		text6: '日语',
		text7: '越南',
	},
	tost:{
		text1: '待开放',
		text2: '请输入提币数量',
		text3: '余额不足',
		text4: '复制成功',
		text5: '至少转出50 USDT',
	},
	
	rlp: {
		text10: "RLP认购",
		text1: "白名单100额度可认购0.1BNB",
		text2: "认购",
		text4: "认购定价",
		text3: "100额度/0.1BNB",
		text5: 'BNB',
		text6: '我的白名单',
		text7: '认购',
		
	},
	aitoken: {
		brand: '核元智算',
		connectWallet: '连接钱包',
		language: '语言',
		tabs: {
			home: '首页',
			business: '业务',
			orders: '订单',
			referral: '推荐',
		},
	},

}
